export var PO_TEXT = 'po';
// Note to intrepid and well-meaning future developers!
//
// The following crusty list is the subject of many silly email chains. It has been discussed at great length
// by a lot of people. It is well-known that it is strange and arbitrary. The eventual intent is to make this
// sort of blacklist retrievable from a better system of record than a constants file locked inside the our
// front end build. However, please also realize that it shouldn't be mucked about with arbitrarily unless you
// really feel like poking bears.
//
export var INVALID_ADDRESS = [
    'PO',
    'P.O.',
    'P.O.B.',
    'PO Box',
    'P.O. Box',
    'PO BOX',
    'POBOX',
    'P O BOX',
    'P. O. BOX',
    'P.O.BOX',
    'P.O. BOX',
    'P O Box',
    'P O BOC',
    'CALLER',
    'CALL BOX',
    'GPO BOX',
    'PO BOXS-',
    'BOX',
    'BUZON',
    'PMB',
    'Post Office Box',
    'Bx',
    'Box',
    'po box',
    'Postal Office',
    'Mail',
    'Mailbox',
];
export var PHONE_FORMAT = {
    DEFAULT: "($1) $2-$3",
    HYPHEN: "$1-$2-$3",
};
export var SSN_FORMAT = "$1-$2-$3";
export var TIN_FORMAT = "$1-$2";
//# sourceMappingURL=textPatterns.js.map